export default "__VITE_PUBLIC_ASSET__f5d26db3__"